<ods-footer [footerInfo]="footerInfo"></ods-footer>